import React from 'react'
import GlassPanel from '../UI/GlassPanel'

/**
 * Artists you marked "want to see" and then didn't catch.
 *
 * Only past events count — on an upcoming event that flag is a plan, not a
 * miss. Artists caught at some other event are labelled, because "missed at
 * Bass Canyon but got them at Lost Lands" is the interesting version.
 */
const MissedArtistsSection = ({ missedArtists = [] }) => {
  if (missedArtists.length === 0) return null

  const stillMissing = missedArtists.filter(artist => !artist.caughtLater)
  const caughtLater = missedArtists.filter(artist => artist.caughtLater)

  return (
    <GlassPanel className="p-6 mb-8">
      <div className="flex items-baseline justify-between gap-3 flex-wrap mb-4">
        <h2 className="text-xl font-bold text-white">🎯 The ones that got away</h2>
        <p className="text-sm text-gray-400">
          Wanted to see, didn't catch
        </p>
      </div>

      {stillMissing.length > 0 && (
        <div className="mb-5">
          <h3 className="text-sm font-medium text-amber-300 uppercase tracking-wide mb-2">
            Still chasing ({stillMissing.length})
          </h3>
          <div className="grid gap-2 sm:grid-cols-2">
            {stillMissing.map(artist => (
              <div
                key={artist.name}
                className="bg-amber-500/10 border border-amber-500/30 rounded-xl px-3 py-2"
              >
                <div className="text-white font-medium truncate">{artist.name}</div>
                <div className="text-xs text-gray-400 truncate">
                  missed at {artist.missedAt.map(m => m.eventName).join(', ')}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {caughtLater.length > 0 && (
        <div>
          <h3 className="text-sm font-medium text-green-300 uppercase tracking-wide mb-2">
            Caught them eventually ({caughtLater.length})
          </h3>
          <div className="flex flex-wrap gap-2">
            {caughtLater.map(artist => (
              <span
                key={artist.name}
                className="bg-green-500/10 border border-green-500/30 rounded-full px-3 py-1 text-sm text-green-100"
                title={`Missed at ${artist.missedAt.map(m => m.eventName).join(', ')}`}
              >
                {artist.name}
              </span>
            ))}
          </div>
        </div>
      )}
    </GlassPanel>
  )
}

export default MissedArtistsSection
